import React, { ReactElement } from 'react';
import CampaignsBreadcrumbs from 'components/Campaigns/Breadcrumb';
import './styles.scss';

interface Props {
  children?: ReactElement;
  title?: string;
}

const CampaignsPageHeader = ({ children = null, title = null }) => {
  return (
    <div className="campaigns-page-header">
      <CampaignsBreadcrumbs
        titles={title !== null ? ['Campaign Overview', title] : ['Campaigns']}
      />
      {children}
    </div>
  );
};

export default CampaignsPageHeader;
